export const DefaultSubscriber = "theplace"

export const QuickNotificationReport  = "QUICK NOTIFICATION"
export const FavouriteReport = "FAVOURITE"